document.addEventListener('DOMContentLoaded', function () {
  function handleScroll() {
    var MainElement = document.querySelector('.custom_bundle');
    if (MainElement) {
      var buttonHeight = MainElement.offsetHeight;
      var buttonOffsetTop = MainElement.offsetTop + buttonHeight;
      var windowHeight = window.innerHeight;
      var buttonOffsetBottom = MainElement.offsetTop;
      setTimeout(() => {
        if (window.scrollY > buttonOffsetBottom && window.scrollY < buttonOffsetTop - 150) {
          MainElement.querySelector('.free_shipping_header_main').classList.add('sticky_bundle_header');
          MainElement.classList.add('sticky_bundle_main_container');
        } else {
          MainElement.querySelector('.free_shipping_header_main').classList.remove('sticky_bundle_header');
          MainElement.classList.remove('sticky_bundle_main_container');
        }
      }, 300);
    }
  }

  handleScroll();

  window.addEventListener('scroll', function () {
    handleScroll();
  });

  const sizeSelectElement = document.querySelectorAll('.product__info-wrapper .custom-select select');
  if(sizeSelectElement) {
    sizeSelectElement.forEach((sizeSelect) => {
        sizeSelect.addEventListener('change', function (e) {
          const selectedValue = e.currentTarget.value;
          const radioInput = e.currentTarget.closest('fieldset').querySelector(`.size-option-list input[type="radio"][value="${selectedValue}"]`);
          if (radioInput && !radioInput.disabled) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
    })
  }
  
  

  window.updateSizeDropDown = function () {
    document.querySelectorAll('[data-option-slug="size"]').forEach((el) => {
      const inputs = el.querySelectorAll('input');
      inputs.forEach((input) => {
        const optionValue = input.dataset.optionValue;
        const fieldset = input.closest('fieldset');
        const selectOption = fieldset.querySelector(`.custom-select select option[value="${optionValue}"]`);
        if (!selectOption) {
          return;
        }
        selectOption.disabled = input.disabled;
      });
    });
  };
});

var swiper = new Swiper('.reveiw_slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slideToClickedSlide: true,
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
    },
  },
});
